import { render, staticRenderFns } from "./ContractImage.vue?vue&type=template&id=0445dcd4&"
import script from "./ContractImage.vue?vue&type=script&lang=ts&"
export * from "./ContractImage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports